import { getLogger } from '../logger';

/**
 * 指定されたURLからファイルをダウンロードし、指定されたファイル名で保存します。
 * CSVファイルをダウンロードする場合の利用を想定しています。
 *
 * @param url - ダウンロードするファイルのURL
 * @param filename - 保存するファイル名
 */
export const downloadFile = async (url: string, filename: string): Promise<void> => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const downloadTag = document.createElement('a');
    downloadTag.href = URL.createObjectURL(blob);
    downloadTag.download = filename;
    downloadTag.click();
  } catch (error) {
    getLogger().error('Failed to download file', undefined, error);
  }
};

/**
 * CORSエラーを回避してファイルを直接ダウンロードします。
 * S3などの外部URLからのダウンロード時にCORSエラーが発生する場合に使用します。
 *
 * @param url - ダウンロードするファイルのURL
 * @param filename - 保存するファイル名
 */
export const downloadFileDirectly = (url: string, filename: string): void => {
  try {
    const downloadTag = document.createElement('a');
    downloadTag.href = url;
    downloadTag.download = filename;
    downloadTag.target = '_blank';
    downloadTag.rel = 'noopener noreferrer';
    downloadTag.click();
  } catch (error) {
    getLogger().error('Failed to download file directly', undefined, error);
  }
};

/**
 * Blobデータをファイルとしてダウンロードします。
 * APIから取得したBlobレスポンスをダウンロードする場合に使用します。
 *
 * @param blob - ダウンロードするBlobデータ
 * @param filename - 保存するファイル名
 */
export const downloadBlob = (blob: Blob, filename: string): void => {
  try {
    const url = URL.createObjectURL(blob);
    const downloadTag = document.createElement('a');
    downloadTag.href = url;
    downloadTag.download = filename;
    downloadTag.click();
    URL.revokeObjectURL(url);
  } catch (error) {
    getLogger().error('Failed to download blob', undefined, error);
  }
};